import {
    ThemeProvider as ThemeProviderSC,
    createGlobalStyle,
} from "styled-components";
import { STYLED } from "@proda-ai/ui-kit";

import colorsCSS from "./colors.css?inline";
import normalizationsCSS from "./normalizations.css?inline";

const { globalStyles: globalStylesFromProdaUiKit, theme } = STYLED;

const GlobalStyles = createGlobalStyle`
  ${globalStylesFromProdaUiKit}
  ${colorsCSS.toString()}
  ${normalizationsCSS.toString()}
`;

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <ThemeProviderSC theme={theme}>
            <GlobalStyles />
            {children}
        </ThemeProviderSC>
    );
};

export default ThemeProvider;
